import { render, staticRenderFns } from "./NagaizumiKaishuuView.vue?vue&type=template&id=24d2217e&scoped=true&"
import script from "./NagaizumiKaishuuView.vue?vue&type=script&lang=js&"
export * from "./NagaizumiKaishuuView.vue?vue&type=script&lang=js&"
import style0 from "./NagaizumiKaishuuView.vue?vue&type=style&index=0&id=24d2217e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2217e",
  null
  
)

export default component.exports